export default "__VITE_ASSET__0210da13__"